import {
  ALLOWED_LANGUAGES,
  DEFAULT_CURRENCY,
  CZK,
  EUR,
  BASE_URL_EVENTS,
  ALL,
  ONLINE,
  IN_PERSON_TYPE,
  FREE,
} from '../misc/consts';

import { locale } from '../alpine-functions';

export default (courseId = '') => ({
  allowedLanguages: ALLOWED_LANGUAGES,
  city: ALL,
  courseId: courseId,
  selectedCourse: null,
  currentPage: 1,
  dataFetched: false,
  events: [],
  language: ALL,
  locale: locale(),
  money: DEFAULT_CURRENCY,
  month: ALL,
  weekendTerm: false,
  selectedPackage: { packagePrice: 0, packageTitle: null },

  get filteredEvents() {
    let filteredEvents = this.$store.events.get();
    if (this.city !== ALL) {
      if (this.city === ONLINE) {
        filteredEvents = filteredEvents.filter(
          (event) => event.event_type !== IN_PERSON_TYPE
        );
      } else {
        filteredEvents = filteredEvents.filter(
          (event) => event.city == this.city
        );
      }
    }
    if (this.month !== ALL) {
      filteredEvents = filteredEvents.filter((event) => {
        return event.start.substring(0, 7) === this.month;
      });
    }
    if (this.language !== ALL) {
      filteredEvents = filteredEvents.filter(
        (event) => event.language == this.language
      );
    }
    if (this.weekendTerm !== false) {
      filteredEvents = filteredEvents.filter((event) => {
        let date = new Date(event.start).getDay();
        return (
          (date === 6 && event.duration <= 2) ||
          (date === 0 && event.duration <= 1)
        );
      });
    }
    if (this.selectedCourse) {
      filteredEvents = filteredEvents.filter((event) => {
        return event.title === this.selectedCourse;
      });
    }
    return filteredEvents;
  },

  get eventsEndpoint() {
    return this.courseId !== ''
      ? `${BASE_URL_EVENTS}course/${this.courseId}`
      : BASE_URL_EVENTS;
  },

  get showAllCourses() {
    return this.courseId === '';
  },

  get perPage() {
    return this.showAllCourses ? 20 : 7;
  },

  get visibileRows() {
    return this.currentPage * this.perPage;
  },

  get buttonShow() {
    return this.dataFetched && this.filteredEvents.length > this.visibileRows;
  },

  get cities() {
    const cities = [
      ...new Set(this.$store.events.get().map((event) => event.city)),
    ];
    const event_types = [
      ...new Set(this.$store.events.get().map((event) => event.event_type)),
    ];
    if (event_types.includes('online') || event_types.includes('both')) {
      cities.push('Online');
    }
    return cities;
  },

  get courses() {
    return [
      ...new Set(this.$store.events.get().map((event) => event.title)),
    ].sort(function (a, b) {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
  },

  get months() {
    const dates = this.$store.events.get().map((event) => event.start);
    const months = dates.map((date) => ({
      humanized: new Date(date).toLocaleDateString(this.locale, {
        month: 'long',
        year: 'numeric',
      }),
      raw: date.substring(0, 7),
    }));

    return [
      ...new Map(months.map((month) => [month['humanized'], month])).values(),
    ];
  },

  get languages() {
    const lang = [
      ...new Set(this.$store.events.get().map((event) => event.language)),
    ];
    return this.allowedLanguages.filter((language) => {
      return lang.includes(language.locale);
    });
  },

  setActiveCurrency(currency) {
    if (this.money == currency) {
      return 'events-table__currency-type--active';
    }
  },

  display(index) {
    return index < this.visibileRows;
  },

  increasePage() {
    this.currentPage++;
  },

  init() {
    this.getEvents();
  },

  formatedMoney(czk, eur) {
    if (parseInt(czk) === 0 && parseInt(eur) === 0) {
      return FREE;
    }
    if (this.money === DEFAULT_CURRENCY) {
      return `${parseInt(czk).toLocaleString(this.locale)} ${CZK}`;
    }
    return `${parseInt(eur).toLocaleString(this.locale)} ${EUR}`;
  },

  getEvents() {
    fetch(this.eventsEndpoint)
      .then((response) => response.json())
      .then((response) => {
        this.$store.events.set(response);
      })
      .then(() => {
        this.dataFetched = true;
        this.$store.events.dataFetched = true;
      });
  },
});
